<template>
  <ReflectModal
    :title-message="$t('settings.dataQuality.title')"
    @cancel="closeModal()"
  >
    <div class="container">
      <p class="container__title">
        {{ $t('settings.dataQuality.dataNormalization') }}
      </p>
      <template
        v-for="field in normalizationFields"
        :key="field"
      >
        <div
          class="container__field"
          @click="navigateToNormalization(field)"
        >
          <ReflectIconButton icon="icon-normalization" />
          <p class="field">
            {{
              $t(
                `settings.dataNormalization.module.normalizationFields.${field}`
              )
            }}
          </p>
        </div>
      </template>
    </div>
  </ReflectModal>
</template>

<script lang="ts">
import { ROUTE } from '~/constants/routes'
import { QUERY_PARAMETERS } from '~/types/queryParameters'
import type { NormalizedFieldEntry } from '~/types/sourceValue'
import type { DateRange } from '~/types/timeDimension'

export default {
  name: 'DataQualityModal',
  props: {
    normalizationFields: {
      type: Object as PropType<NormalizedFieldEntry[]>,
      required: true
    },
    dateRange: {
      type: Object as PropType<DateRange>,
      required: true
    }
  },
  emits: {
    'close-modal': () => true
  },
  methods: {
    closeModal() {
      this.$emit('close-modal')
    },
    async navigateToNormalization(field: NormalizedFieldEntry) {
      await navigateTo(
        {
          path: ROUTE.SETTINGS__INTEGRATIONS__NORMALIZATION,
          query: {
            [QUERY_PARAMETERS.NORMALIZATION_FIELD]: field,
            [QUERY_PARAMETERS.START_DATE]: this.dateRange[0],
            [QUERY_PARAMETERS.END_DATE]: this.dateRange[1]
          }
        },
        { open: { target: '_blank' } }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid $border-quaternary;

  &__title {
    @include font-text($font-weight-medium);
    @include font-size($font-size-mini);
    margin: $margin-small 0 $margin-mini $margin-regular;
  }

  &__field {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0 $margin-tiny $margin-regular;

    .field {
      @include font-text($font-weight-book);
      @include font-size($font-size-mini);
      margin-left: $margin-mini;
    }

    &:hover {
      cursor: pointer;
    }

    &:last-of-type {
      margin-bottom: $margin-mini;
    }
  }
}
</style>
